import React, { useState } from "react";
import useStyles from "./styles";
import LoginSignUpModal from "../../../Login/loginSignUpModal";
import Box from "@material-ui/core/Box";
import Typography  from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import  Link  from "@material-ui/core/Link";
import DefaultLogo from "../../../../../assets/images/defaultLogo.png";
import { thumborImageUrl } from "../../../../../Utility";
import MobileNavDrawer from "../11/mobile-navbar";
import MenuIcon from "@material-ui/icons/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Menu from "@material-ui/core/Menu";
import InstagramIcon from "@material-ui/icons/Instagram";
import FacebookIcon from "@material-ui/icons/Facebook";
import TwitterIcon from "@material-ui/icons/Twitter";
import YouTubeIcon from "@material-ui/icons/YouTube";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import { useTheme } from "@material-ui/core/styles";
import useMemeberInfo from "../../../../../dataHook/useMemeberInfoHook";
import useNavbarInfo from "../../../../../dataHook/useNavHook";
import useSocialLinks from "../../../../../dataHook/useSocialMediaLinks";
const Component19 = ({ websiteData, widgetList }) => {
  const classes = useStyles();
  const [showLogin, setShowLogin] = useState(false);  
  const [showMenuDrawer, setShowMenuDrawer] = useState(false);
  const [showKnowMore, setShowKnowMore] = useState(null);
  const [showLoginDropDown, setShowLoginDropDown] = useState(false);
  const theme = useTheme();
  const {username = null,user = {},isLoggedIn} = useMemeberInfo();
  const {logo_url,contentArr  = [],handleLogout=()=>{}} = useNavbarInfo();
  const socialLinks  = useSocialLinks();
  if(contentArr?.length <= 0) return null;
  let [loginObj] = contentArr?.filter((obj) => obj.name == "Login");
  let updatedContentArr = contentArr?.filter((obj) => obj.name != "Login");
  const DropDownType = ({ isBtn = false, items = [] }) => {
    let { name = "", link = "", id = "" } = items;
    if (id == "logout") {
      return <MenuItem onClick={handleLogout}>{name}</MenuItem>;
    } else if (link) {  
      return (
        <MenuItem
          style={{
            textTransform: "capitalize",
          }}
          component={"a"}
          href={link}
        >
          {name}
        </MenuItem>
      );
    } else {
      return <MenuItem>{name}</MenuItem>;
    }
  };

  let { dropDownItem: loginDropDown = [] } = loginObj;

  const handleClick = (event) => {
    setShowKnowMore(event.currentTarget);
  };

  const handleClose = () => {
    setShowKnowMore(null);
  };

  const handleClickLogin = (event) => {
    setShowLoginDropDown(event.currentTarget);
  };

  const handleCloseLogin = () => {
    setShowLoginDropDown(null);
  };
  const socialLogos = {
    Instagram: InstagramIcon,
    Facebook: FacebookIcon,
    Twitter: TwitterIcon,
    Youtube: YouTubeIcon,
    Linkedin: LinkedInIcon,
  };
  return (
    <>
      <div className={classes.header}>
        <div className={classes.footerHead}>
          <div className={classes.contactContainer}>
            <Grid
              item
              style={{
                display: "flex",
                alignItems: "center",
                flexDirection: "row",
                justifyContent: "flex-start",
              }}
            >
              {socialLinks?.map((socialItem, index) => {
                const Logo = socialLogos[socialItem.type];

                return (
                  <Link
                    key={index}
                    href={socialItem.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    underline="none"
                    style={{
                      borderLeft:
                        index === 0
                          ? `1px solid ${theme?.agentTheme?.card?.muted_foreground}`
                          : "none",
                      borderRight: `1px solid ${theme?.agentTheme?.card?.muted_foreground}`,
                      paddingLeft: index === 0 ? "1rem" : "0",
                      marginRight: "1rem",
                      height: "40px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Box
                      style={{
                        color: theme?.agentTheme?.card?.foreground,
                        cursor: "pointer",
                        height: "15px",
                        width: "15px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginRight: "1rem",
                      }}
                    >
                      <Logo style={{ fontSize: "1.1rem" }} />
                    </Box>
                  </Link>
                );
              })}
            </Grid>
          </div>
          <div className={classes.loginContainer}>
            {isLoggedIn ? (
              <>
                <Box
                  style={{ cursor: "pointer" }}
                  display={"flex"}
                  onClick={handleClickLogin}
                >
                  <Typography> {`Hi ${user?.username || ''}`}</Typography>
                  <Box display={"flex"} alignItems={"center"}>
                    <ExpandMoreIcon color="primary.contrastText" />
                  </Box>
                </Box>
                <Menu
                  getContentAnchorEl={null}
                  anchorOrigin={{
                    vertical: "bottom",
                  }}
                  transformOrigin={{
                    vertical: "top",
                  }}
                  anchorEl={showLoginDropDown}
                  keepMounted
                  open={Boolean(showLoginDropDown)}
                  onClose={handleCloseLogin}
                  className={classes.dropdownContainerLogin}
                >
                  {loginDropDown.map((items) => {
                    let { isBtn = false } = items;
                    return <DropDownType items={items} isBtn={isBtn} />;
                  })}
                </Menu>
              </>
            ) : (
              <span
                className={classes.loginButton}
                onClick={() => setShowLogin(true)}
              >
                Login
              </span>
            )}
          </div>
        </div>
        <div className={classes.footerTail}>
          <Box
            display="flex"
            alignItems="center"
            style={{
              padding: "20px 14px",
            }}
            className={classes.menu}
          >
            <MenuIcon
              className={classes.menuIcon}
              onClick={() => setShowMenuDrawer(true)}
            />
            <MobileNavDrawer
              widgetList={widgetList}
              websiteData={websiteData}
              showDrawer={showMenuDrawer}
              setShowDrawer={setShowMenuDrawer}
              contentArr={contentArr}
            />
          </Box>

          <Box style={{ display: "flex", alignItems: "center" }}>
            <img
              className={classes.logoImg}
              src={logo_url ? thumborImageUrl(logo_url, 0, 100) : DefaultLogo}
              onClick={() => {
                window.location.href = `/${username ? `${username}` : ""}`;
              }}
            />
          </Box>

          <Box display="flex" className={classes.navbar}>
            {updatedContentArr.map((item) => {
              let { isDropdown = false, dropDownItem = [] } = item;
              return isDropdown ? (
                <Box
                  display={"flex"}
                  flexDirection={"column"}
                  alignItems={"center"}
                  justifyContent={"center"}
                >
                  <Box
                    aria-controls="simple-menu"
                    aria-haspopup="true"
                    onClick={handleClick}
                    display={"flex"}
                    alignItems={"center"}
                  >
                    <a
                      href={item.link}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                        cursor: "pointer",
                      }}
                      className={classes.navItem}
                    >
                      {item.name}
                      <ExpandMoreIcon
                        style={{
                          color: "inherit",
                        }}
                      />
                    </a>
                  </Box>
                  <Menu
                    getContentAnchorEl={null}
                    anchorOrigin={{
                      vertical: "bottom",
                    }}
                    transformOrigin={{
                      vertical: "top",
                    }}
                    anchorEl={showKnowMore}
                    keepMounted
                    open={Boolean(showKnowMore)}
                    onClose={handleClose}
                  >
                    {dropDownItem.map((items) => {
                      let { isBtn = false } = items;
                      return <DropDownType items={items} isBtn={isBtn} />;
                    })}
                  </Menu>
                </Box>
              ) : (
                <a href={item.link} className={classes.navItem}>
                  {item.name}
                </a>
              );
            })}
          </Box>
        </div>
      </div>
      {showLogin && <LoginSignUpModal onClose={() => setShowLogin(false)} />}
    </>
  );
};

export default Component19;
